import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ROLE_PATHS = {
  healer: '/healer',
  patient: '/patient',
  student: '/student',
  general: '/general',
};

const Impersonate = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('t');
    const role = params.get('role');
    const firstName = params.get('name') || 'User';

    if (!token || !role) {
      navigate('/login');
      return;
    }

    // Store in sessionStorage only — this tab gets the impersonated session,
    // the admin tab (using localStorage) is completely unaffected.
    sessionStorage.setItem('pwc_token', token);
    sessionStorage.setItem('pwc_user', JSON.stringify({ role, firstName }));

    const path = ROLE_PATHS[role] || '/login';
    navigate(path, { replace: true });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default Impersonate;
